var _defs, _line, _polyline, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeamOlandezWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b97ef68f-ca13-41a5-bafc-7396a4aabcf3",
    "data-name": "geam_olandez",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 201 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a2f0917f-31e8-480b-936b-9d6780e30f17,.b03f0cc1-fa05-4a4a-a907-f7737db537e3,.e68103f6-4e7e-4441-848a-4044fa3d126f,.f8ea6dfe-dc40-40f4-9ebf-f25b7f4fe0cc{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.b03f0cc1-fa05-4a4a-a907-f7737db537e3{stroke-width:10px;}.a2f0917f-31e8-480b-936b-9d6780e30f17{stroke-width:8px;}.f8ea6dfe-dc40-40f4-9ebf-f25b7f4fe0cc{stroke-width:3px;}.e68103f6-4e7e-4441-848a-4044fa3d126f{stroke-width:5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "geam_olandez_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b03f0cc1-fa05-4a4a-a907-f7737db537e3",
    x1: 40,
    y1: 5,
    x2: 160,
    y2: 5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "b03f0cc1-fa05-4a4a-a907-f7737db537e3",
    points: "159.81 5 159.81 110 196 195 5 195 39.18 110 39.18 5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a2f0917f-31e8-480b-936b-9d6780e30f17",
    x1: 59.5,
    y1: 96,
    x2: 140.5,
    y2: 96
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a2f0917f-31e8-480b-936b-9d6780e30f17",
    x1: 59.5,
    y1: 23,
    x2: 140.5,
    y2: 23
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "a2f0917f-31e8-480b-936b-9d6780e30f17",
    x1: 59.5,
    y1: 23,
    x2: 59.5,
    y2: 94.8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "a2f0917f-31e8-480b-936b-9d6780e30f17",
    x1: 140.5,
    y1: 23,
    x2: 140.5,
    y2: 96
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "f8ea6dfe-dc40-40f4-9ebf-f25b7f4fe0cc",
    x1: 39.5,
    y1: 110,
    x2: 159.5,
    y2: 110.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "a2f0917f-31e8-480b-936b-9d6780e30f17",
    x1: 45,
    y1: 171,
    x2: 155,
    y2: 171
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "a2f0917f-31e8-480b-936b-9d6780e30f17",
    x1: 145,
    y1: 125,
    x2: 55,
    y2: 125
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "a2f0917f-31e8-480b-936b-9d6780e30f17",
    x1: 55,
    y1: 125,
    x2: 45,
    y2: 171
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "a2f0917f-31e8-480b-936b-9d6780e30f17",
    x1: 145,
    y1: 125,
    x2: 155,
    y2: 171
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "e68103f6-4e7e-4441-848a-4044fa3d126f",
    x1: 115.6,
    y1: 32.12,
    x2: 129.9,
    y2: 45.9
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "e68103f6-4e7e-4441-848a-4044fa3d126f",
    x1: 98.29,
    y1: 32.76,
    x2: 129.24,
    y2: 62.57
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "e68103f6-4e7e-4441-848a-4044fa3d126f",
    x1: 69.78,
    y1: 162.88,
    x2: 59.32,
    y2: 152.82
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "e68103f6-4e7e-4441-848a-4044fa3d126f",
    x1: 82.42,
    y1: 162.42,
    x2: 59.81,
    y2: 140.64
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeamOlandezWhite);
export default __webpack_public_path__ + "static/media/geam_olandez_white.fe806786d38ec25882e8e5cff7749a97.svg";
export { ForwardRef as ReactComponent };